import { useContext } from 'react';
import { ProductOptionContext } from './product-option-context.mjs';

const useProductOptionContext = () => {
    const ctx = useContext(ProductOptionContext);
    if (!ctx) {
        throw new Error("useProductOptionContext must be used within a ProductOptionProvider");
    }
    return ctx;
};

export { useProductOptionContext };
//# sourceMappingURL=use-product-option-context.mjs.map
